module.exports = __webpack_public_path__ + "img/b32c9d2.png";